<template>
  <div class="delivery-title">빈 박스 수령일</div>
  <div class="date-row">
    <div class="input-group relative">
      <flatPickr
          :model-value="delivery_date" @update:model-value="setDeliveryDate"
          :config="dateConfigForDelivery"
          class="date-pick input del-date-input"
          @on-change="onChangeDeliveryDate"
      ></flatPickr>
      <span v-if="!delivery_date" class="placeholder">날짜선택</span>
      <i class="xi-calendar icn-date-picker"></i>
<!--      <Datepicker :model-value="delivery_date" @update:model-value="setDeliveryDate"-->
<!--                  week-start="0"-->
<!--                  :enable-time-picker="false"-->
<!--                  :min-date="getDeliveryMinDate" :max-date="getDeliveryMaxDate"-->
<!--                  :teleport="true"-->
<!--                  format="yyyy-MM-dd"-->
<!--                  locale="ko-KR"-->
<!--                  select-text="완료"-->
<!--                  cancel-text="취소"-->
<!--                  placeholder="날짜선택"-->
<!--      >-->
<!--        <template #input-icon>-->
<!--          <i class="xi-calendar input-slot-img"></i>-->
<!--        </template>-->
<!--      </Datepicker>-->
    </div>
    <div class="time-wrap relative">
      <select v-model="delivery_timeFromParent" tabindex="-1" class="input">
        <option value="none" selected>시간선택</option>
        <option v-for="idx in 10" :key="idx" :value="getTimeFormat(idx)" :disabled="getTimeDisable('delivery', idx)">{{ (8 + idx).toString().padStart(2, '0') }}:00{{getTimeDisable('delivery', idx) ? '(선택불가)' : ''}}</option>
      </select>
      <i class="xi-time-o"></i>
    </div>
  </div>

  <div class="delivery-title">박스 수거일</div>
  <div class="date-row">
    <button class="btn btn-sm btn-default-square" :class="[isImmediateCollection ? 'btn-primary' : 'btn-default']" @click="onClickImmediateBtn(true)">즉시수거</button>
    <button class="btn btn-sm btn-default-square" :class="[isImmediateCollection ? 'btn-default' : 'btn-primary']" @click="onClickImmediateBtn(false)">사용자지정</button>
  </div>
  <div class="date-row mt-2" v-if="!isImmediateCollection">
    <div class="input-group relative">
      <flatPickr
          :model-value="collection_date" @update:model-value="setCollectionDate"
          :config="dateConfigForCollection"
          class="date-pick input col-date-input"
      ></flatPickr>
      <span v-if="!collection_date" class="placeholder">날짜선택</span>
      <i class="xi-calendar icn-date-picker"></i>
<!--      <DatePick-->
<!--          :model-value="collection_date" @update:model-value="setCollectionDate"-->
<!--          :startWeekOnSunday="true"-->
<!--      ></DatePick>-->
<!--      <Datepicker :model-value="collection_date" @update:model-value="setCollectionDate"-->
<!--                  week-start="0"-->
<!--                  :enable-time-picker="false"-->
<!--                  :min-date="getCollectionMinDate" :max-date="getCollectionMaxDate"-->
<!--                  :teleport="true"-->
<!--                  format="yyyy-MM-dd"-->
<!--                  locale="ko-KR"-->
<!--                  select-text="완료"-->
<!--                  cancel-text="취소"-->
<!--                  placeholder="날짜선택"-->
<!--      >-->
<!--        <template #input-icon>-->
<!--          <i class="xi-calendar input-slot-img"></i>-->
<!--        </template>-->
<!--      </Datepicker>-->
    </div>
    <div class="time-wrap relative">
      <select v-model="collection_timeFromParent" tabindex="-1" class="input">
        <option value="none">시간선택</option>
        <option v-for="idx in 10" :key="idx" :value="getTimeFormat(idx)" :disabled="getTimeDisable('collection', idx)">{{ (8 + idx).toString().padStart(2, '0') }}:00</option>
      </select>
      <i class="xi-time-o"></i>
    </div>
  </div>
</template>


<script>
import dayjs from "dayjs";
import _CONST from "@/store/const";
import apiSchedule from "@/api/schedule";

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import { Korean } from 'flatpickr/dist/l10n/ko.js';

export default {
  name: "TheStorageDeliveryDate",
  components: {
    flatPickr
  },
  props: [
    'delivery_date',
    'delivery_time',
    'collection_date',
    'collection_time',
    'type',
    'box_cnt'
  ],
  emits: [
      'update:delivery_date',
      'update:delivery_time',
      'update:collection_date',
      'update:collection_time',
  ],
  watch: {
    async 'delivery_date'() {

      if (!dayjs(this.delivery_date).isValid() || dayjs(this.delivery_date).diff(this.getDeliveryMinDate, 'day') >= 0) {
        // 날짜 변경시 시간 초기화.
        this.$emit('update:delivery_time', 'none');

        if (dayjs(this.delivery_date).isValid()) await this.updateScheduleTimeList('delivery');

        if (this.isImmediateCollection) {
          this.$emit('update:collection_date', this.delivery_date);
        }
      } else {
        alert("선택 불가능한 날짜입니다.");
      }
    },
    async 'delivery_time'() {
      if (this.isImmediateCollection) {
        this.$emit('update:collection_time', this.delivery_time);
      }
    },
    async 'collection_date'() {
      if (!this.isImmediateCollection && this.collection_date !== null) {
        await this.updateScheduleTimeList('collection');
      }
    },
    isImmediateCollection() {
      if (this.isImmediateCollection) {
        this.$emit('update:collection_date', this.delivery_date);
        this.$emit('update:collection_time', this.delivery_time);
      } else {
        this.$emit('update:collection_date', null);
        this.$emit('update:collection_time', 'none');
      }
    }
  },
  computed: {
    isMobileDevice() {
      return /Mobi|Android/i.test(navigator.userAgent);
    },
    delivery_dateFromParent: {
      get() { return this.delivery_date; },
      set(newValue) {
        if (!dayjs(newValue).isValid()) newValue = null;
        this.$emit('update:delivery_date', newValue);
      }
    },
    delivery_timeFromParent: {
      get() { return this.delivery_time; },
      set(newValue) { this.$emit('update:delivery_time', newValue); }
    },
    collection_dateFromParent: {
      get() { return this.collection_date; },
      set(newValue) {
        if (!dayjs(newValue).isValid()) newValue = null;
        this.$emit('update:collection_date', newValue);
      }
    },
    collection_timeFromParent: {
      get() { return this.collection_time; },
      set(newValue) { this.$emit('update:collection_time', newValue); }
    },
    getDeliveryMaxDate() {
      let max = dayjs().add(_CONST.MAX_WORK_DATE, 'day').format('YYYY-MM-DD');

      return max;
    },
    getDeliveryMinDate() {
      let curTime = dayjs().format('HH');
      if (curTime <= 15) {
        return dayjs().add(1, 'day').format('YYYY-MM-DD');
      } else {
        return dayjs().add(2, 'day').format('YYYY-MM-DD');
      }
    },

    getCollectionMaxDate() {
      let max = dayjs().format('YYYY-MM-DD');
      // 배송일 기준 7일 후 까지.
      if (this.delivery_date) {
        max = dayjs(this.delivery_date).add(7, 'day').format('YYYY-MM-DD');
      }

      return max;
    },
    getCollectionMinDate() {
      if (this.delivery_date) {
        return dayjs(this.delivery_date).format('YYYY-MM-DD');
      } else {
        return dayjs().add(1, 'day').format('YYYY-MM-DD');
      }
    },
  },
  data() {
    let curTime = dayjs().format('HH');

    let minDateForDel = dayjs().add(2, 'day').format('YYYY-MM-DD');
    let maxDateForDel = dayjs().add(_CONST.MAX_WORK_DATE, 'day').format('YYYY-MM-DD');

    if (curTime <= 15) minDateForDel = dayjs().add(1, 'day').format('YYYY-MM-DD');

    let maxDateForCol = dayjs().format('YYYY-MM-DD');

    let minDateForCol = dayjs().add(2, 'day').format('YYYY-MM-DD');
    if (curTime <= 15) minDateForCol = dayjs().add(1, 'day').format('YYYY-MM-DD');

    return {
      dateConfigForDelivery: {
        dateFormat: "Y-m-d",
        minDate: minDateForDel,
        maxDate: maxDateForDel,
        locale: Korean
      },
      dateConfigForCollection: {
        dateFormat: "Y-m-d",
        minDate: minDateForCol,
        maxDate: maxDateForCol,
        locale: Korean
      },
      timeList: {
        delivery: [],
        collection: []
      },
      isImmediateCollection: true
    }
  },
  methods: {
    // setPlaceholder() {
    //   const input = this.$el.querySelector('input');
    //   if (input) {
    //     input.placeholder = this.placeholderText;
    //   }
    // },
    onClickImmediateBtn(isImmediate) {
      if (!this.delivery_date) return alert("박스 수령일을 먼저 선택해주세요.");

      this.isImmediateCollection = isImmediate;
    },
    onChangeDeliveryDate(selectedDates) {
      let newData = dayjs(selectedDates).format('YYYY-MM-DD');
      this.$emit('update:collection_date', newData);

      this.isImmediateCollection = true;

      this.dateConfigForCollection.minDate = dayjs(selectedDates).format('YYYY-MM-DD');
      this.dateConfigForCollection.maxDate = dayjs(selectedDates).add(7, 'day').format('YYYY-MM-DD');
    },
    setDeliveryDate(date) {
      let newData = dayjs(date).isValid() ? dayjs(date).format('YYYY-MM-DD') : null;
      this.$emit('update:delivery_date', newData);
    },
    setCollectionDate(date) {
      let newData = dayjs(date).isValid() ? dayjs(date).format('YYYY-MM-DD') : null;
      this.$emit('update:collection_date', newData);
    },
    /**
     * 배송, 수거일 변경시 가능한 시간대 갱신.
     * @param type
     * @returns {Promise<void>}
     */
    async updateScheduleTimeList(type) {
      let date = type === 'delivery' ? this.delivery_date : this.collection_date;

      if (date) {
        this.timeList[type] = await apiSchedule.getListForDelivery(date);
      }
    },
    isAvailableTime(time, type) {
      let cnt = this.box_cnt;

      // console.log(`time: ${time}`)
      // console.log(`cnt <= 10 && this.type !== 'delivery': ${cnt <= 10 && this.type !== 'delivery'}`);
      // console.log(`cnt: ${cnt}`);
      if (cnt <= 10 && this.type !== 'delivery') {
        // console.log('this.timeList[type][time]: ' + this.timeList[type][time]);
        if (this.timeList[type] && this.timeList[type][time]) {
          return true;
        }
      } else if (cnt <= 30) {
        if (time > 16) return false;
        if (this.timeList[type] && this.timeList[type][time] && this.timeList[type][time + 1]) return true;
      } else {
        if (time > 15) return false;
        if (this.timeList[type] && this.timeList[type][time] && this.timeList[type][time + 1] && this.timeList[type][time + 2]) return true;
      }

      return false;
    },
    getTimeDisable(type, idx) {
      // let diff = idx >= 4 ? 1 : 0;
      let isAvailableByDeliveryTime = true;
      let time = idx + 8;

      if (type === 'collection') {
        if (this.collection_date && this.delivery_date === this.collection_date) {
          let deliveryTime = Number(this.delivery_time.split(':')[0]);
          isAvailableByDeliveryTime = time > deliveryTime;
        }
      }

      let isAvailableBySchedule = this.isAvailableTime(time, type);

      // console.log('isAvailableByDeliveryTime: '+isAvailableByDeliveryTime);
      // console.log(`time: ${time} / isAvailableByDeliveryTime: ${isAvailableByDeliveryTime}`);
      return !isAvailableByDeliveryTime || !isAvailableBySchedule;
    },
    getTimeFormat(idx) {
      return (idx + 8).toString().padStart(2, '0') + ":00";
    },
  }
}
</script>

<style scoped lang="scss">
.delivery-title {
  font-size: 12px;
  font-weight: 900;
  margin-top: 25px;
  margin-bottom: 8px;
}

.mobile-placeholder::placeholder {
  color: #000;
}

.icn-date-picker {
  position: absolute;
  top: 13px;
  left: 10px;
}

.date-pick input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
}

.date-pick input {
  text-align: left;
}

input[type="date"]::-webkit-datetime-edit-text,
input[type="date"]::-webkit-datetime-edit-month-field,
input[type="date"]::-webkit-datetime-edit-day-field,
input[type="date"]::-webkit-datetime-edit-year-field {
  color: #000;
}

input[type='date'] {
  padding-left: 33px;

  &::-webkit-date-and-time-value {
    text-align: right;
  }
}

input[type='date']::-webkit-calendar-picker-indicator {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  color: transparent;
  cursor: pointer;
}

.input-slot-img {
  color: #000;
  margin-left: 13px;
}

//input[type='date'] + i {
//  position: absolute;
//  top: 12px;
//  left: 13px;
//}

select + i {
  position: absolute;
  top: 12px;
  left: 13px;
}

.time-wrap select {
  padding-left: 30px;
}

.date-row {
  display: flex;
  justify-content: space-between;

  > * {
    width: 49%;
  }

  .input-group {
    margin-bottom: 0;
  }

  .btn-default-square {
    font-size: 15px;

    @include respond(mobile) {
      font-size: 12px;
    }
  }
  button.btn-default-square + .btn-default-square {
    margin-top: 0;
  }
}

.btn-confirm-order {
  height: 55px;
  border-radius: 5px;
}

.btn-load-address {
  font-size: 10px;
  line-height: 24px;
  float: right;
  padding: 0 10px;
}

.date-pick {
  height: 40px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  font-size: 12px;
  border-radius: 5px;
  color: #000;
  width: 100%;
  border: 1px solid $light-grey;

  &::placeholder {
    color: #000 !important;
    opacity: 1;
    font-size: 12px;
  }
}

select option:disabled {
  background-color: #d3d3d3;
  color: #888888;
}
</style>
<style lang="scss">
.delivery-modal, .storage-request-modal {
  .input, .dp__input_wrap > input {
    height: 40px;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 12px;
    border-radius: 5px;
    color: #000;
    border-color: $light-grey;

  }

  .dp__input_wrap > input::placeholder {
    color: #000 !important;
    opacity: 1;
    font-size: 12px;
  }

  .date-pick {
    background-color: #fff !important;
    padding-left: 30px;
  }

  input[type='date']:valid::after {
    display: none;
  }

  input.date-pick + span.placeholder {
    width: 100%;
    font-size: 12px;
    position: absolute;
    top: 14px;
    left: 30px;
    pointer-events: none;
  }
}

.dp__action_button {
  white-space: nowrap;
}
</style>
